import React from 'react';
import { loadState } from '../../_core/localStorage';
import { Route, Redirect } from 'react-router-dom';

const AuthenticatedRoute = ({ component: Component, ...rest }) => {
  const userState = loadState();
  const isAuthenticated = userState.role === 'user' && userState.loggedIn;
  const isConfirmed = userState.isConfirmed;

  return (
    <Route
      {...rest}
      render={props => {
        // Check if user is authenticated first
        if (!isAuthenticated) {
          return (
            <Redirect
              to={{ pathname: '/user/login', state: { from: props.location } }}
            />
          );
        }

        // Check if user's email is confirmed (but allow access to OTP verification page)
        if (isConfirmed === false && props.location.pathname !== '/user/otp-verification') {
          return (
            <Redirect
              to={{ pathname: '/user/otp-verification', state: { from: props.location } }}
            />
          );
        }

        // User is authenticated and confirmed, or trying to access OTP page
        return <Component {...props} />;
      }}
    />
  );
};

export default AuthenticatedRoute;
